import { createFileRoute } from '@tanstack/react-router';
import { useEffect, useRef, useState } from 'react';

export const Route = createFileRoute('/mobile-auth-challenge')({ component: MobileAuthChallenge });

type Turnstile = { render: (element: HTMLElement, options: Record<string, unknown>) => string; remove: (id: string) => void };
function MobileAuthChallenge() {
  const container = useRef<HTMLDivElement>(null);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    const bridge = window as typeof window & { ReactNativeWebView?: { postMessage: (value: string) => void }; turnstile?: Turnstile };
    const send = (status: string, token?: string) => bridge.ReactNativeWebView?.postMessage(JSON.stringify({ type: 'wordpuppi-registration-challenge', status, ...(token ? { token } : {}) }));
    const sitekey = import.meta.env.VITE_TURNSTILE_SITE_KEY as string | undefined;
    if (!sitekey) { send('disabled'); return; }
    let widget: string | undefined;
    let active = true;
    const error = () => { if (active) { setFailed(true); send('error'); } };
    const render = () => {
      if (!active || !container.current || !bridge.turnstile) return;
      try {
        widget = bridge.turnstile.render(container.current, {
          sitekey, theme: 'auto', callback: (token: string) => send('complete', token),
          'expired-callback': () => send('expired'), 'error-callback': error,
          'timeout-callback': () => send('expired'),
        });
      } catch { error(); }
    };
    const script = document.createElement('script');
    script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
    script.async = true; script.onload = render; script.onerror = error;
    if (bridge.turnstile) render(); else document.head.appendChild(script);
    return () => { active = false; if (widget && bridge.turnstile) bridge.turnstile.remove(widget); script.remove(); };
  }, []);
  return <main style={{ padding: 8 }}><div ref={container} />{failed ? <p>Security check could not load. Retry in the app.</p> : null}</main>;
}
